import { Stack, Text, PrimaryButton } from '@fluentui/react'
import { useAuth } from '../auth/AuthProvider'

const Unauthorized = () => {
  const { logout } = useAuth()

  return (
    <Stack verticalAlign="center" horizontalAlign="center" styles={{ root: { flex: 1, height: '100%', gap: 16 } }}>
      <Text variant="xxLarge">Unauthorized</Text>
      <Text variant="medium">You do not have permission to access this application.</Text>
      <PrimaryButton text="Sign Out" onClick={() => logout()} />
    </Stack>
  )
}

export default Unauthorized
